/**
 * Plantilla Oficial Única — Split Sheet | Acuerdo de Participaciones
 * Medellín Music Lab
 * Alineada 1:1 con el documento oficial "Split Sheet.docx"
 */

export const PLANTILLA_SPLIT_SHEET_EPG = `
# SPLIT SHEET | ACUERDO DE PARTICIPACIONES
**Obra musical · autorización de fijación · identificación del productor fonográfico**
MEDELLÍN MUSIC LAB

---

## 1. Obra y sesión

{{tabla_obra_sesion}}

---

## 2. Participantes y reparto de la obra musical

El porcentaje corresponde únicamente a la participación convenida en los derechos patrimoniales de autor de la COMPOSICIÓN, no al fonograma, a la interpretación ni a los ingresos del máster.

{{tabla_participantes}}

Las partes acuerdan que las participaciones indicadas representan el 100 % de la titularidad patrimonial de autor que reconocen entre los firmantes sobre esta obra. Dichas participaciones son convenidas libremente por los firmantes y pueden reconocerse a cualquier participante, incluido el productor musical, con independencia de su rol en la sesión. Los derechos morales permanecen en cabeza de sus autores conforme a la ley aplicable.

---

## 3. Designación del productor fonográfico

Selección obligatoria:  {{seleccion_productor_linea}}

{{tabla_productor_fonografico}}

Los participantes que suscriben el presente Split Sheet, de manera libre, expresa e informada, aceptan y reconocen que **{{productor_nombre_declarado}}**, identificado(a) con **{{productor_documento_declarado}}**, es el (la) PRODUCTOR(A) FONOGRÁFICO(A) del fonograma resultante de esta sesión de grabación y, en consecuencia, titular exclusivo(a) de los derechos patrimoniales sobre dicho fonograma (MÁSTER). En esa condición podrá reproducirlo, distribuirlo, comercializarlo, comunicarlo públicamente, ponerlo a disposición del público, licenciarlo y explotarlo económicamente, directamente o por terceros, en cualquier territorio y por cualquier medio, durante el término de protección legal.

---

## 4. Autorizaciones de los participantes grabados

Cada persona con voz o interpretación/ejecución incorporada al audio responde individualmente:

{{tabla_autorizaciones_grabados}}

Cada participante cuya voz, interpretación o ejecución haya quedado incorporada en la grabación debe responder individualmente la autorización anterior. La respuesta afirmativa autoriza al (la) productor(a) fonográfico(a) a explotar dicha interpretación o ejecución en los términos de la sección 3. Si alguna persona marca «No», su intervención no podrá utilizarse mientras no exista autorización válida o se retire del fonograma.

---

## 5. Aceptación y firma electrónica

Cada firmante confirma sus datos, aporte y porcentaje de derechos patrimoniales de autor cuando corresponda; acepta expresamente la designación del productor fonográfico identificado en la sección 3 y las autorizaciones individuales que haya otorgado. Las partes manifiestan que han leído y aceptan libremente este documento. El productor fonográfico designado debe firmar para dejar constancia de su aceptación y de la condición declarada. Con la firma del presente Split Sheet, cada firmante declara que su aporte es original y no infringe derechos de terceros.

{{tabla_firmas_electronicas}}

Medellín Music Lab facilita el diligenciamiento y conserva el registro; no adquiere derechos por esa sola intervención. El monitor solo verifica que el flujo de diligenciamiento se haya completado, sin certificar titularidades ni asesorar individualmente a las partes.

---
*Medellín Music Lab  |  Split Sheet digital*
`;

export const PLANTILLA_COMPOSICION_MEDELLIN = PLANTILLA_SPLIT_SHEET_EPG;
